(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', function() {
    const bannerBg = document.querySelector('[id^="lena-banner-bg-"]');
    if (!bannerBg) return;
    const rate = parseFloat(bannerBg.getAttribute('data-parallax')) || 0.4;
    function updateParallax() {
      bannerBg.style.transform = 'translate3d(0, ' + (window.scrollY * rate) + 'px, 0)';
    }
    window.addEventListener('scroll', updateParallax, { passive: true });
    updateParallax();
  });

  } catch(e) { console.error(e); }
})();
})();
